import styled, {createGlobalStyle, keyframes} from "styled-components";
import ButtonStyle from "@material-ui/core/Button";
import IconButtonStyle from "@material-ui/core/IconButton";

export const GlobalStyle = createGlobalStyle`
    #root {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        font-family: 'open-sans', sans-serif;
        font-size: 14px;
        font-weight: 600;
    }
    
    html,body,#root {
        display: flex;
        margin: 0;
        padding: 0;
        height: 100%;
        width: 100%;
    }
    
    
    .hidden {
        display: none;
    }
`


export const Button = styled(ButtonStyle)`
    && {
        position: fixed;
        right: 32px;
        bottom: 32px;
        background-color: #B90066;
        color: #ffffff;
        padding: 9px 16px;
        border-radius: 3px;
        span {
            font-size: 18px;
            text-wrap: none;
            text-transform: none;
            svg {
                margin-right: 11px;
                height: 20px;
            }
        }
    }
`

export const IconButton = styled(IconButtonStyle)`
    && {
        color: #ffffff;
        svg {
            height: 13px;
        }
    }
`

export const Header = styled.div`
    color: #ffffff;
    display: flex;
    height: 54px;
    padding: 0 5px 0 17px;
    justify-content: center;
    align-items: center;
    background: #95267B;
    background-size: 100px, 100%;
    gap: 8px;
    >div {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 18px;
        
    }
    img {
        height: 30px;
        padding: 7px 0;
        border-radius: 50%;
    }
`

export const Container = styled.div`
    
    max-width: 100%;
    width: 100%;
    height: 100%;
    border-radius:0;
    overflow: hidden;
    filter: drop-shadow(0px 30px 40px rgba(0, 0, 0, 0.15));
    @media(max-width: 500px) {
        height: 100%;
        width: 100%;
        border-radius: 0;
        right: unset;
        bottom: unset;
    }
`

